module.exports = __webpack_public_path__ + "static/media/immersive-insights.0edc3e57.jpg";